export default function Sidebar({
    isOpen,
    onClose,
    onLogout,
    visibleItems,
    userRights,
    isAdmin,
    onToggleItem,
}) {
    return (
        <>
            {isOpen && <div className="overlay" onClick={onClose}></div>}
            <div
                className={`sidebar d-flex flex-column p-3 text-white ${
                    isOpen ? "open" : ""
                }`}
            >
                <button
                    className="btn-close btn-close-white align-self-start"
                    onClick={onClose}
                ></button>
                <h4 className="text-center mb-4">Налаштування</h4>

                <div className="flex-grow-1">
                    {Object.keys(visibleItems).map((item) => {
                        const userRightKey = `ur${item
                            .charAt(0)
                            .toUpperCase()}${item.slice(1)}`;

                        if (userRights[userRightKey] !== 1 && isAdmin !== 1) return null;

                        return (
                            <div
                                className="form-check form-switch my-3"
                                key={item}
                            >
                                <input
                                    className="form-check-input bg-secondary border-0"
                                    type="checkbox"
                                    id={item}
                                    checked={visibleItems[item].show}
                                    onChange={() => onToggleItem(item)}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={item}
                                >
                                    {visibleItems[item].label}
                                </label>
                            </div>
                        );
                    })}
                </div>

                <button
                    className="btn main--button mt-auto align-self-end"
                    onClick={onLogout}
                >
                    Вихід
                </button>
            </div>
        </>
    );
}
